/*
  Entry point of the Application
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';

const cognitoConfig = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_jLCPO2GRq',
  userPoolClientId: 'ivndm1pupsb9682a202dti4u0',
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
};

Amplify.configure({
  Auth: {
    Cognito: cognitoConfig,
  },
  Storage: {
    S3: {
      region: 'us-east-1',
      bucket: 'petriboothproject' 
    },
  },
  PubSub: {
      aws_pubsub_region: 'us-east-1', 
      aws_pubsub_endpoint: 'wss://a1ycg31vcj54dy-ats.iot.us-east-1.amazonaws.com/mqtt', 
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
